/*
 * @Author: ailin
 * @Date: 2022-10-11 15:58:02
 * @LastEditors: ailin
 * @LastEditTime: 2022-10-13 14:04:47
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/coupon/couponTurn/couponTurn.js
 */
import { queryCouponGiftBagDetail, receiveCouponGiftBag } from "@/libs/api.js";

export default {
	name: "couponTurn",
	components: {},
	data() {
		return {
			Coupons: [
				
			],
			loading: false,
		};
	},
	computed: {
	},
	methods: {
		// 获取优惠券信息
		getCouponList() {
            queryCouponGiftBagDetail({giftBagId:this.$route.query.giftBagId}, "jsoncallback").then((res) => {
                this.loading = false
                if (res.returnCode == "0000" || res.code == "0000") {
                    this.Coupons = res.returnMsg.couponList
                } else {
                    this.$toast(res.msg);
                }
            },()=>{
                this.loading = false
            });
		},
        getCoupon(coupon){//领取优惠券
			// 已登录
			if (this.$cookies.get("mall_cookie") || this.$cookies.get("ul_utk")) {
				receiveCouponGiftBag({giftBagId:this.$route.query.giftBagId,couponCode:coupon.code}, "jsoncallback").then((res) => {
					if (res.returnCode == "0000" || res.code == "0000") {
						this.$toast("领取成功");
                        this.getCouponList()
						//神策埋点
						window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_CouponsReceive', {
							ylyx_coupon_code: coupon.code,
							ylyx_coupon_type: '满减',
							ylyx_coupon_name: coupon.remark || ''
						});
					} else {
                        if (res.msg) {
                            this.$toast(res.msg);
                        }else
						this.$toast("领取优惠券失败");
					}
				});
			}
			// 未登录
			else {
				let targetUrl = location.href
				console.log(targetUrl);
				this.$dialog
					.confirm({
						title: "提示",
						message: "请先登录",
					})
					.then(() => {
						if (this.$browser().miniprogram) {
							window.wx.miniProgram.navigateTo({
								url: "/pages/authorize?target=" + encodeURIComponent(targetUrl) + "&type=webView", //跳转非tabBar页面(目前就指非首页index)。参数以路径后面拼接即可
							});
						} else {
							window.location.href = `//m.${this.$uleUrl()}/muser/user/login?target=${encodeURIComponent(targetUrl)}`;
						}
					})
					.catch(() => {
						this.active = 0;
					});
			}
        },
		onLoad() {
			console.log("onLoad");
		},
	},
	created() {},
	mounted() {
        this.getCouponList()
	},
};
